import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IAccesoModel } from 'src/app/models/interfaces/accesos/IAccessoModel';
import { IContratistaAccesoPersonalResult } from 'src/app/models/interfaces/accesos/IContratistaAccesoPersonalResult';
import { IDeshabilitarAccesoPersonalResult } from 'src/app/models/interfaces/accesos/IDeshabilitarAccesoPersonalResult';
import { IDeshabilitarAccesosBatchModel } from 'src/app/models/interfaces/accesos/IDeshabilitarAccesosBatchModel';
import { IFilterAccesoModel } from 'src/app/models/interfaces/accesos/IFilterAccesoModel';
import { IFilterDeshabilitarAccesoPersonalModel } from 'src/app/models/interfaces/accesos/IFilterDeshabilitarAccesoPersonalModel';
import { IVigilanciaAccesoPersonalResult } from 'src/app/models/interfaces/accesos/IVigilanciaAccesoPersonalResult';
import { AccesoModel } from 'src/app/models/queries/accesos/AccessoModel';
import { IInduccionResultadoBusquedaModel } from 'src/app/models/queries/inducciones/interfaces/IInduccionResultadoBusquedaModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccesoPersonaService {
  private configUrl = [environment.apiGatewayUrl, 'accesos-personal'].join('/');
  
  constructor(private http: HttpClient,
    private datepipe: DatePipe
    ) { }

  getById(id: number): Observable<AccesoModel> {
    return this.http.get<AccesoModel>(`${this.configUrl}/${id}`);
  }

  getByCode(id: string): Observable<IAccesoModel> {
    return this.http.get<IAccesoModel>(`${this.configUrl}/codigo/${id}`);
  }

  getImage(id: number): Observable<Blob> {
    return this.http.get(`${this.configUrl}/${id}/download-qr`, { responseType: 'blob' });
  }

  // VigilanciaAccesoPersonalResult implements  
  getListVigilante(
    model: IFilterAccesoModel
  ): Observable<SearchResultModel<IVigilanciaAccesoPersonalResult[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }
    
    if(model.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(model.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(model.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }    

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if (model.subContratista !== '') {
      queryParams.push(`subContratista=${model.subContratista}`);
    }

    return this.http.get<SearchResultModel<IVigilanciaAccesoPersonalResult[]>>(
      `${this.configUrl}/vigilancia/?${queryParams.join('&')}`
    );
  }

  getListVigilanteToExport(
    model: IFilterAccesoModel
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }
    
    if(model.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(model.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(model.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }    

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if (model.subContratista !== '') {
      queryParams.push(`subContratista=${model.subContratista}`);
    }

    return this.http.get(
      `${this.configUrl}/vigilancia/exportar/?${queryParams.join('&')}`, { responseType: 'blob'}
    );
  }

  getListDeshabilitar(
    model: IFilterDeshabilitarAccesoPersonalModel
  ): Observable<SearchResultModel<IDeshabilitarAccesoPersonalResult[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if(model.fechaInicioServicio){
      queryParams.push(`fechaInicioServicio=${this.datepipe.transform(model.fechaInicioServicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinServicio){
      queryParams.push(`fechaFinServicio=${this.datepipe.transform(model.fechaFinServicio, 'yyyy-MM-dd')}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }
    
    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`); 
    }
    
    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get<SearchResultModel<IDeshabilitarAccesoPersonalResult[]>>(
      `${this.configUrl}/deshabilitar/?${queryParams.join('&')}`
    );
  }

  getListDeshabilitarToExport(
    model: IFilterDeshabilitarAccesoPersonalModel
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if(model.fechaInicioServicio){
      queryParams.push(`fechaInicioServicio=${this.datepipe.transform(model.fechaInicioServicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinServicio){
      queryParams.push(`fechaFinServicio=${this.datepipe.transform(model.fechaFinServicio, 'yyyy-MM-dd')}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }
    
    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`); 
    }
    
    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get(
      `${this.configUrl}/deshabilitar/exportar?${queryParams.join('&')}`, { responseType: 'blob'}
    );
  }

  getListReestablecer(
    model: IFilterDeshabilitarAccesoPersonalModel
  ): Observable<SearchResultModel<IDeshabilitarAccesoPersonalResult[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if(model.fechaInicioServicio){
      queryParams.push(`fechaInicioServicio=${this.datepipe.transform(model.fechaInicioServicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinServicio){
      queryParams.push(`fechaFinServicio=${this.datepipe.transform(model.fechaFinServicio, 'yyyy-MM-dd')}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }
    
    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`); 
    }
    
    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get<SearchResultModel<IDeshabilitarAccesoPersonalResult[]>>(
      `${this.configUrl}/reestablecer/?${queryParams.join('&')}`
    );
  }

  getListReestablecerToExport(
    model: IFilterDeshabilitarAccesoPersonalModel
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if(model.fechaInicioServicio){
      queryParams.push(`fechaInicioServicio=${this.datepipe.transform(model.fechaInicioServicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinServicio){
      queryParams.push(`fechaFinServicio=${this.datepipe.transform(model.fechaFinServicio, 'yyyy-MM-dd')}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }
    
    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`); 
    }
    
    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get(
      `${this.configUrl}/reestablecer/exportar?${queryParams.join('&')}`, { responseType: 'blob'}
    );
  }

  getListPorContratista(
    model: IFilterAccesoModel
  ): Observable<SearchResultModel<IContratistaAccesoPersonalResult[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    // queryParams.push(`idEstado=${model.idEstado}`);

    if(model.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(model.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(model.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    if (model.subContratista !== '') {
      queryParams.push(`subContratista=${model.subContratista}`);
    }

    return this.http.get<SearchResultModel<IContratistaAccesoPersonalResult[]>>(
      `${this.configUrl}/por-contratista/?${queryParams.join('&')}`
    );
  }

  getListPorContratistaToExport(
    model: IFilterAccesoModel
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    // queryParams.push(`idEstado=${model.idEstado}`);

    if(model.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(model.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(model.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    if (model.subContratista !== '') {
      queryParams.push(`subContratista=${model.subContratista}`);
    }

    return this.http.get(
      `${this.configUrl}/por-contratista/exportar?${queryParams.join('&')}`, { responseType: 'blob'}
    );
  }

  deshabilitar(model: IDeshabilitarAccesosBatchModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/deshabilitar`, model);
  }

  reestablecer(model: IDeshabilitarAccesosBatchModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/reestablecer`, model);
  }
}
